import MapConstants from 'constants/map/map';
import LocationService from 'views/utils/LeafletMap/MapServices/LocationService';
import scriptjs from 'scriptjs';

var HERELocationService = function(args) {
    LocationService.apply(this, args);
    return this;
};

HERELocationService.prototype = Object.create(LocationService.prototype);
HERELocationService.prototype.constructor = HERELocationService;

HERELocationService.prototype.fetch = function fetch(options, context) {
    let execute = () => {
        var platform = new H.service.Platform({
                apiKey: MapConstants.HereApiKey,
                useHTTPS: true
            }),
            geocoder = platform.getSearchService(),
            geocodingParameters = {
                q: options.address
            };

        geocoder.geocode(
            geocodingParameters,
            function(result) {
                if (result.items && result.items.length > 0) {
                    var position = result.itemst[0].position;
                    options.success.call(context, {
                        address: options.address,
                        location: [position.lat, position.lng]
                    });
                } else {
                    options.error.call(context, result, 'Unexpected data returned.');
                }
            },
            function(error) {
                options.error.call(context, error, 'Unexpected data returned.');
            }
        );
    };

    scriptjs('//js.api.here.com/v3/3.1/mapsjs-core.js', () => {
        scriptjs(
            ['//js.api.here.com/v3/3.1/mapsjs-core-legacy.js', '//js.api.here.com/v3/3.1/mapsjs-service.js'],
            () => {
                scriptjs('//js.api.here.com/v3/3.1/mapsjs-service-legacy.js', () => {
                    execute();
                });
            }
        );
    });
};

export default HERELocationService;
